var render = function render(){var _vm=this,_c=_vm._self._c;return _c('td',{staticClass:"square-wrapper"},[_c('div',{staticClass:"square-inner"},[_c('div',{staticClass:"correlation-viz",style:(_vm.squareStyle)}),_c('div',{staticClass:"value"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showNumber),expression:"showNumber"}]},[_vm._v(_vm._s(Number(_vm.value).toFixed(2)))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }